import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { updateUser } from '../actions/userActions';
import {openModal, resetModal} from '../actions/modalsActions';
import i18n from '../utils/i18n';
import Modal from './Modal';
import {modals} from "../utils/constants";
import information_icon from '../images/information_icon.svg';

class WelcomeModal extends React.Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.learnAboutPremium = this.learnAboutPremium.bind(this);
  }

  dismissWelcomeModal() {
    this.props.updateUser({
      dismissed_welcome_dialogue: true
    });
  }

  learnAboutPremium() {
    this.props.updateUser({
      learned_about_premium: true,
      dismissed_welcome_dialogue: true
    });
    this.props.openModal(modals.LEARN_ABOUT_PREMIUM);
  }

  close() {
    this.props.resetModal();
    this.dismissWelcomeModal();
  }

  render() {
    const { first_name: firstName, last_name: lastName } = this.props.user;

    return (
      <Modal
        isOpen={ true }
        onRequestClose={ this.close }
        closeButtonText={ i18n.t('modals.welcome.CONTINUE') }
        actionButtonText={ i18n.t('modals.welcome.LEARN_ABOUT_DEUCE_PREMIUM') }
        actionFunction={  this.learnAboutPremium }
      >
        <div className={ 'modal-container' }>
          <h1 className="modal-header">
            {i18n.t('modals.welcome.WELCOME', {
              name: `${firstName || ''} ${lastName || ''}`
            })}
          </h1>
          <p>{i18n.t('modals.welcome.WE_ARE_GOING_TO_SIMPLIFY')}</p>
          <p>{i18n.t('modals.welcome.SOON')}</p>
        </div>

        <div className={ 'modal-notification' }>
          <div className={ 'notification-icon' }>
            <img src={ information_icon } alt={ 'Notification' } />
          </div>
          {i18n.t('modals.welcome.FREE_SESSION_INFORMATION_1ST_LINE')}<br/>
          {i18n.t('modals.welcome.FREE_SESSION_INFORMATION_2ND_LINE')}
        </div>

      </Modal>
    );
  }
}

WelcomeModal.propTypes = {
  resetModal: PropTypes.func.isRequired,
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  updateUser: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  user: state.auth.user
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  updateUser: params => dispatch(updateUser(params)),
  resetModal: () => dispatch(resetModal()),
  openModal: (modal, modalData) => dispatch(openModal(modal, modalData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeModal);



// WEBPACK FOOTER //
// ./src/modals/WelcomeModal.js